export default "__VITE_ASSET__DCIgY6IL__"